(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["play-better-guarantee"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-play-better-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (dialog && !dialog.open) dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

})();
